import { render, staticRenderFns } from "./addressAdd.vue?vue&type=template&id=0d477b6c&scoped=true&"
import script from "./addressAdd.vue?vue&type=script&lang=js&"
export * from "./addressAdd.vue?vue&type=script&lang=js&"
import style0 from "./addressAdd.vue?vue&type=style&index=0&id=0d477b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d477b6c",
  null
  
)

export default component.exports